import { Component, Input } from '@angular/core';
import { BaseChangesTable } from '../base-table-changes';
import { UsesType } from 'src/shared/enums/uses.type.enum';

@Component({
    standalone: false,
    selector: 'uses-changes-table',
    templateUrl: './uses-changes-table.component.html',
    styleUrls: ['../base-changes-style.scss']

})
export class UsesChangesTableComponent extends BaseChangesTable {
    @Input()
    calibrationUsesLabels: any;

    usesRow = ['Use name', 'Status'];

    getTypeNameById(id) {
        return UsesType[id];
    }
}
